import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { querytimescaleUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export interface EventsForSourceParams {
  namespace: string;
  /** IMM (machine) source id. */
  source: string;
  /** Event type identifier, e.g. "IMMCycleParametersEventType". */
  eventType: string;
  /** How many events to read. The tree call asks for 1; the chart call asks
   *  for the user's chosen count when the x-axis is the event index. */
  size?: number;
  /** Time window, used when the x-axis is `occurred_at`. */
  from?: string;
  to?: string;
}

export const getEventsForSourceAPI = async ({
  namespace,
  source,
  eventType,
  size,
  from,
  to,
}: EventsForSourceParams) => {
  const url = querytimescaleUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v1/ns/${namespace}/imms/${source}/events`,
      {
        headers,
        params: {
          event_type: eventType,
          // Always read from the tail: the tree is built from the newest event,
          // and a chart window anchored at the head is never what we want.
          position: "tail",
          size,
          from,
          to,
        },
      },
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const { message, status } = parseAxiosApiError(
      error,
      "Failed to fetch events",
    );

    return {
      success: false,
      error: message,
      status,
    };
  }
};
